import { render, staticRenderFns } from "./configManagement.vue?vue&type=template&id=6a18558a&scoped=true&"
import script from "./configManagement.vue?vue&type=script&lang=js&"
export * from "./configManagement.vue?vue&type=script&lang=js&"
import style0 from "./configManagement.vue?vue&type=style&index=0&id=6a18558a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a18558a",
  null
  
)

export default component.exports